export const GET_PROFILE_LIST_DATA_REQUEST =
  "GET_PROFILE_LIST_DATA_REQUEST";
export const GET_PROFILE_LIST_DATA_SUCCESS =
  "GET_PROFILE_LIST_DATA_SUCCESS";
export const GET_PROFILE_LIST_DATA_FAILURE =
  "GET_PROFILE_LIST_DATA_FAILURE";

export const GET_GIF_DATA = "GET_GIF_DATA"
